(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("polyglot"));
	else if(typeof define === 'function' && define.amd)
		define(["polyglot"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("polyglot")) : factory(root["polyglot"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return 